/**
 * Created by Anthony on 24/05/2019.
 */

export class User {
  set acountStatus(value: string) {
    this._acountStatus = value;
  }
  set id(value: number) {
    this._id = value;
  }

  set email(value: string) {
    this._email = value;
  }

  set mobile(value: string) {
    this._mobile = value;
  }

  set userType(value: string) {
    this._userType = value;
  }

  set role(value: Role) {
    this._role = value;
  }

  set createdByUserId(value: number) {
    this._createdByUserId = value;
  }

  set firstName(value: string) {
    this._firstName = value;
  }

  set lastName(value: string) {
    this._lastName = value;
  }

  set address(value: string) {
    this._address = value;
  }

  set altMobileNo(value: string) {
    this._altMobileNo = value;
  }

  set profileImage(value: string) {
    this._profileImage = value;
  }

  set walletBalance(value: number) {
    this._walletBalance = value;
  }

  set freezedAmount(value: number) {
    this._freezedAmount = value;
  }

  set walletCommissionBalance(value: number) {
    this._walletCommissionBalance = value;
  }

  set passwordChanged(value: number) {
    this._passwordChanged = value;
  }

  set mobileVerified(value: number) {
    this._mobileVerified = value;
  }

  set deleted(value: number) {
    this._deleted = value;
  }

  set blocked(value: number) {
    this._blocked = value;
  }

  set active(value: number) {
    this._active = value;
  }

  set isApiUser(value: boolean) {
    this._isApiUser = value;
  }

  set lastLoginDate(value: number) {
    this._lastLoginDate = value;
  }

  set createdDate(value: number) {
    this._createdDate = value;
  }

  set updatedDate(value: any) {
    this._updatedDate = value;
  }
  get id(): number {
    return this._id;
  }

  get email(): string {
    return this._email;
  }

  get mobile(): string {
    return this._mobile;
  }

  get userType(): string {
    return this._userType;
  }

  get role(): Role {
    return this._role;
  }

  get createdByUserId(): number {
    return this._createdByUserId;
  }

  get firstName(): string {
    return this._firstName;
  }

  get lastName(): string {
    return this._lastName;
  }

  get address(): string {
    return this._address;
  }

  get altMobileNo(): string {
    return this._altMobileNo;
  }

  get profileImage(): string {
    return this._profileImage;
  }

  get walletBalance(): number {
    return this._walletBalance;
  }

  get freezedAmount(): number {
    return this._freezedAmount;
  }

  get walletCommissionBalance(): number {
    return this._walletCommissionBalance;
  }

  get passwordChanged(): number {
    return this._passwordChanged;
  }

  get mobileVerified(): number {
    return this._mobileVerified;
  }

  get deleted(): number {
    return this._deleted;
  }

  get blocked(): number {
    return this._blocked;
  }

  get active(): number {
    return this._active;
  }

  get isApiUser(): boolean {
    return this._isApiUser;
  }

  get lastLoginDate(): number {
    return this._lastLoginDate;
  }

  get createdDate(): number {
    return this._createdDate;
  }

  get updatedDate(): any {
    return this._updatedDate;
  }

  get acountStatus(): string {
     this._acountStatus = this._blocked ? 'Account Inactive' : 'Account active';
    return this._acountStatus;
  }

  get walletTransferStatus(): string {
    this._walletTransferStatus = this._isApiUser ? 'Wallet transfer enabled' : 'Wallet transfer disabled';
    return this._walletTransferStatus;
  }


  private _acountStatus:            string;
  private _id:                      number;
  private _email:                   string;
  private _mobile:                  string;
  private _userType:                string;
  private _role:                    Role;
  private _createdByUserId:         number;
  private _firstName:               string;
  private _lastName:                string;
  private _address:                 string;
  private _altMobileNo:             string;
  private _profileImage:            string;
  private _walletBalance:           number;
  private _freezedAmount:           number;
  private _walletCommissionBalance: number;
  private _walletTransferStatus:    string;
  private _passwordChanged:         number;
  private _mobileVerified:          number;
  private _deleted:                 number;
  private _blocked:                 number;
  private _active:                  number;
  private _isApiUser:               boolean;
  private _lastLoginDate:           number;
  private _createdDate:             number;
  private _updatedDate:             null;

  constructor(obj: any) {
    this._id = obj.id;
    this._email = obj.email;
    this._mobile = obj.mobile;
    this._userType = obj.userType;
    this._role = obj.role;
    this._createdByUserId = obj.createdByUserId;
    this._firstName = obj.firstName;
    this._lastName = obj.lastName;
    this._address = obj.address;
    this._altMobileNo = obj.altMobileNo;
    this._profileImage = obj.profileImage;
    this._walletBalance = obj.walletBalance;
    this._freezedAmount = obj.freezedAmount;
    this._walletCommissionBalance = obj.walletCommissionBalance;
    this._passwordChanged = obj.passwordChanged;
    this._mobileVerified = obj.mobileVerified;
    this._deleted = obj.deleted;
    this._blocked = obj.blocked;
    this._active = obj.active;
    this._isApiUser = obj.isApiUser;
    this._lastLoginDate = obj.lastLoginDate;
    this._createdDate = obj.createdDate;
    this._updatedDate = obj.updatedDate;
  }
}

export interface Role {
  id:          number;
  name:        string;
  userType:    string;
  createdDate: number;
  updatedDate: null;
  permissions: Permission[];
}

export interface Permission {
  id:          number;
  name:        string;
  groupName:   string;
  createdDate: number;
  updatedDate: null;
}



// WEBPACK FOOTER //
// ./src/app/services/users-service/user.model.ts